import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";
import React, { useEffect, useState } from "react";
import {
  fetchParentCategories,
  fetchSubCategories,
  fetchChildCategories,
  fetchBrandMappings,
} from "../../../../Redux/filters/slice";
import { fetchProducts } from "../../../../Redux/ecommersProduct/slice";
import ChildCategoreProducts from "./ChildCategoreProducts";
import ChildCategorieFilter from "./ChildCategorieFilter";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import FilterDetails from "../../mobilecategories/minifilters/FilterDetails";
import Filters from "../../mobilecategories/minifilters/Filters";
import SideCart from "../../../globalcomponents/SideCart/SideCart";

const ChildCategorie = () => {
  const dispatch = useAppDispatch();

  // Hardcoded for now as per requested "supercategory from params"
  const superCategory = "Clothing";

  const [filters, setFilters] = useState({
    parentCategory: "Women",
    subCategory: "Women's Kurtas & Kurtis", // Default for ChildCategorie page demo
    childCategory: "",
    brandId: "",
    minPrice: undefined as number | undefined,
    maxPrice: undefined as number | undefined,
    page: 1,
    limit: 20,
  });

  const { parentCategories, subCategories, childCategories, brandMappings } =
    useAppSelector((state) => state.filters);
  const { products, loading, pagination, error } = useAppSelector(
    (state) => state.eCommerceProducts,
  );

  useEffect(() => {
    dispatch(fetchParentCategories({ superCategory , showOnFilters:true , showOnWebsite:true }));
    dispatch(fetchBrandMappings({ superCategory, page: 1, limit: 100 }));
  }, [superCategory, dispatch]);

  useEffect(() => {
    if (filters.parentCategory) {
      dispatch(fetchSubCategories({ parentCategory: filters.parentCategory , showOnFilters:true , showOnWebsite:true }));
    }
  }, [filters.parentCategory, dispatch]);

  useEffect(() => {
    if (filters.subCategory) {
      dispatch(fetchChildCategories({ subCategory: filters.subCategory , showOnFilters:true , showOnWebsite:true }));
    }
  }, [filters.subCategory, dispatch]);

  useEffect(() => {
    dispatch(
      fetchProducts({
        superCategory,
        category: filters.parentCategory || undefined,
        subCategory: filters.subCategory || undefined,
        childCategory: filters.childCategory || undefined,
        brandId: filters.brandId || undefined,
        minPrice: filters.minPrice,
        maxPrice: filters.maxPrice,
        page: filters.page,
        limit: filters.limit,
      }),
    );
  }, [superCategory, filters, dispatch]);

  const handleFilterChange = (newFilters: Partial<typeof filters>) => {
    setFilters((prev) => ({ ...prev, ...newFilters, page: 1 }));
  };

  const handlePageChange = (newPage: number) => {
    setFilters((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container">
          <div className="d-flex mt-0">
            <div className="border-end h-auto justify-content-center text-start h-auto w-15">
              <div>
                <ChildCategorieFilter
                  superCategory={superCategory}
                  parentCategories={parentCategories.data}
                  subCategories={subCategories.data}
                  childCategories={childCategories.data}
                  brandMappings={brandMappings.data}
                  filters={filters}
                  onFilterChange={handleFilterChange}
                />
              </div>
            </div>
            <div className=" container">
              <ChildCategoreProducts
                products={products}
                loading={loading.products}
                error={error}
              />
              {pagination.totalPages > 1 && (
                <ul className="pagination pagination-dark d-flex justify-content-center pagination-lg mt-5">
                  <li
                    className={`page-item ${pagination.page === 1 ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link p-2"
                      onClick={() => handlePageChange(pagination.page - 1)}
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">
                        <i className="material-symbols-rounded">
                          keyboard_double_arrow_left
                        </i>
                      </span>
                    </button>
                  </li>
                  {[...Array(pagination.totalPages)].map((_, i) => (
                    <li
                      key={i}
                      className={`page-item ${pagination.page === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link p-2 px-3"
                        onClick={() => handlePageChange(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${pagination.page === pagination.totalPages ? "disabled" : ""}`}
                  >
                    <button
                      className="page-link p-2"
                      onClick={() => handlePageChange(pagination.page + 1)}
                      aria-label="Next"
                    >
                      <span aria-hidden="true">
                        <i className="material-symbols-rounded">
                          keyboard_double_arrow_right
                        </i>
                      </span>
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-center p-2 shadow-card bg-white position-fixed w-100 z-index-3">
          <div>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href="/MiniCategories">
                <i className="ri-arrow-left-s-line fs-3 me-1 text-black"></i>
              </a>
            </li>
          </div>
          <div className=" d-flex gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-search fs-6 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="bi bi-bell fs-5 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <div className=" pt-5">
          <div className=" d-flex justify-content-end align-items-center p-1 px-2">
            <div>
              <button
                className=" btn btn-outline-dark btn-sm text-md"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasFilters"
                aria-controls="offcanvasFilters"
              >
                <i className="fi fi-rr-bars-filter text-xs me-1"></i>Filters
              </button>
            </div>
          </div>
          <div className=" mt-2">
            <ChildCategoreProducts
              products={products}
              loading={loading.products}
              error={error}
            />
          </div>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-bottom bg-purple-subtle min-vh-90"
        id="offcanvasFilters"
        aria-labelledby="offcanvasFiltersLabel"
      >
        <div className=" d-flex justify-content-between align-items-start">
          <div className=" text-end w-70"></div>
          <div>
            <button
              className=" btn text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <li className="avatar avatar-sm border shadow-lg border-radius-2xl opacity-6 bg-white">
                <i className="bi bi-x-lg fs-6 text-black"></i>
              </li>
            </button>
          </div>
        </div>
        <div className="offcanvas-body border-top small">
          <div className="d-flex align-items-start">
            <Filters />
            <div className="tab-content mt-3" id="v-pills-tabContent">
              <FilterDetails />
            </div>
          </div>
        </div>
        <div className=" px-2 mb-2">
          <button className=" btn btn-md btn-dark w-100">Apply</button>
        </div>
      </div>
      <SideCart />
    </>
  );
};

export default ChildCategorie;
